import { motion } from "framer-motion";
import MainNav from "@/components/MainNav";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="about-page">
      <MainNav />

      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-3xl md:text-4xl font-syne font-bold text-white mb-2" data-testid="about-title">About</h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="prose prose-invert max-w-none"
          >
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 md:p-8 space-y-6">
              <p className="text-zinc-300 leading-relaxed">
                Underplay is a company 22 years in the making. It has one clear objective: to ensure the right people hear the right music in the right way, whether that be artists, labels, publishers, producers, bookers, presenters, supervisors, programmers, or directly to the fanbase.
              </p>

              <p className="text-zinc-300 leading-relaxed">
                Our main focus is managing artists we love and promoting music across TV, radio, press, sync, and DSPs. We have been doing this for many years and possess a wealth of knowledge, experience, and contacts we consider friends.
              </p>

              <div className="border-t border-zinc-800 pt-6 mt-6" data-testid="team-section">
                <h2 className="text-xl font-syne font-bold text-white mb-4" data-testid="team-heading">The Team</h2>
                
                <div className="space-y-6">
                  <div data-testid="team-member-chris">
                    <h3 className="text-lg font-semibold text-white">Chris Bellam</h3>
                    <p className="text-zinc-400 text-sm leading-relaxed">
                      Chris set up the company in 2016 and has worked alongside critically acclaimed and chart-topping artists, producers, managers, and creatives since 2001, driven by a passion for great music and a desire to find those who are yet to be discovered. He began his career at XL Recordings.
                    </p>
                  </div>

                  <div data-testid="team-member-mike">
                    <h3 className="text-lg font-semibold text-white">Mike Hale</h3>
                    <p className="text-zinc-400 text-sm leading-relaxed">
                      Mike joined in 2018 from the MOBOs, having previously collaborated with Chris to book FKA Twigs for the awards show, and they have worked together ever since. Together with Chris, Underplay has collaborated with many labels, including 4AD, AWAL, Matador, Marathon, Rough Trade, Young Turks, Island, Polydor, Warner, Virgin, Ninja Tune, Warp, Secretly Canadian, Lucky Number, Glassnote, to mention a few.
                    </p>
                  </div>

                  <div data-testid="team-member-ethan">
                    <h3 className="text-lg font-semibold text-white">Ethan Beer</h3>
                    <p className="text-zinc-400 text-sm leading-relaxed">
                      Ethan joined in 2025 from Satellite 414, having previously worked with Underplay, leading the press campaign for Lynks. Ethan brings nearly a decade of experience in music, fashion, lifestyle, and events PR. Our approach is personal, thoughtful, and built on real relationships. We've secured standout coverage across print, digital, broadcast, and social for both established acts and artists at the start of their journey.
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-t border-zinc-800 pt-6 mt-6">
                <h2 className="text-xl font-syne font-bold text-white mb-4">Artists We've Worked With</h2>
                <p className="text-zinc-400 text-sm leading-relaxed">
                  Over the years, Chris, Mike and Ethan have worked directly with many artists, including ADELE, The xx, Daughter, Sampha, Todd Terje, Queens Of The Stone Age, Sigur Rós, Bon Iver, Grimes, The National, Alabama Shakes, Warpaint, The Strokes, The Horrors, SBTRKT, Bat For Lashes, GHOST, Lucinda Chua, Jamie xx, Dizzee Rascal, Radiohead, Jack Peñate, Laurel, Giggs, Jai Paul, Tyler, The Creator, Vampire Weekend, Bobby Womack, Loyle Carner, Savages, Mystery Jets, Friendly Fires, Lapsley, Jungle, Cat Power, David Byrne, St. Vincent, Jack White, Paul Banks, Basement Jaxx, Scott Walker, White Stripes, MIA, and FKA Twigs.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Logo */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-center mt-12"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_music-connect-23/artifacts/mbsj96z9_UNDERPLAY%20MUSIC%20LOGO%20NEW%202025%20no%20border%20no%20TEXT.png" 
              alt="Underplay" 
              className="h-16 w-auto mx-auto opacity-50"
            />
          </motion.div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-800 py-6">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-zinc-600 text-xs">© 2025 Underplay. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
